import {ITimeoutService} from "angular";
import {regNavn} from "./tredjepartsTjenestenavn";
import _ from "lodash";


export class Throttle {

    static regNavn = "Throttle";

    static forInjisering() {
        return [regNavn.ng.$timeout, Throttle]
    }

    constructor(private $timeout: ITimeoutService) {
    }

    //offentlige metoder

    /**
     * Pakker inn angitt funksjon slik at denne kun blir kalt maks en gang per maxFrekvens millisekunder.
     * Første kall vil skje etter maxFrekvens millisekunder.
     *
     * Utestående kall kan kanseleres ved å kalle cancel() på returverdien fra throttle(..)
     *
     * eks:
     * let throttlet = throttle((a)=>{...}, 10)
     * throttlet(a)
     */
    throttle<T extends Function>(funksjon: T, maxFrekvens?: number): T & _.DebouncedFunc<any> {
        var timeout = null;
        var throttletMetode: any = (...argumenter) => {
            if (timeout) this.$timeout.cancel(timeout);
            timeout = this.$timeout(
                () => funksjon.apply(this, argumenter),
                maxFrekvens);
        };
        throttletMetode.cancel = () => this.$timeout.cancel(timeout);
        return <T & _.DebouncedFunc<any>>throttletMetode;
    }


}
